import { useMutation } from '@tanstack/react-query';
import { deleteContactEmail } from '../../services/fn-api/User';

export const useDeleteContactEmail = () => {
  return useMutation<void, Error, number>({
    mutationFn: async (id: number) => {
      return deleteContactEmail(id);
    },
  });
};
